import {useQuery} from '@tanstack/react-query';
import {consentsApi} from '../api';
import {BenefactorConsentsResponse} from '../model';

export const useBenefactorConsents = (benefactorId: string | undefined) => {
  return useQuery<BenefactorConsentsResponse>({
    queryKey: ['benefactor-consents', benefactorId],
    queryFn: () => consentsApi.getBenefactorConsents(benefactorId!),
    enabled: !!benefactorId,
  });
};
